import React from 'react';
import { useParams } from 'react-router-dom';
import { TransformationForm } from './TransformationForm';

/**
 * Full-page transformation create/edit.
 * Reuses TransformationForm; the same form is also used in the detail page settings panel.
 */
export const TransformationFormPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  return <TransformationForm transformationId={id} mode="page" />;
};
